import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Globe, MapPin } from "lucide-react";
import { LogoLockup } from "./Logo";

export default function Footer() {
    return (
        <footer className="bg-[#0A0A0A] text-white relative overflow-hidden" data-testid="site-footer">
            <div className="absolute inset-0 bg-grid-dark opacity-40 pointer-events-none" />
            <div className="container-lended relative py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
                    <div className="md:col-span-5">
                        <LogoLockup size={48} dark />
                        <p className="mt-6 text-white/65 max-w-md leading-relaxed">
                            Lended is a direct funder for ISOs and small businesses moving serious volume.
                            Fast approvals. Real closings. Built for high-dollar deals up to $3M.
                        </p>
                        <div className="mt-8 space-y-3">
                            <a href="mailto:submissions@lended.com" className="flex items-center gap-3 text-white/80 hover:text-[#FF6B1A] transition" data-testid="footer-email">
                                <Mail size={16} className="text-[#FF6B1A]" /> submissions@lended.com
                            </a>
                            <div className="flex items-center gap-3 text-white/80">
                                <Globe size={16} className="text-[#FF6B1A]" /> lended.com
                            </div>
                            <div className="flex items-center gap-3 text-white/60">
                                <MapPin size={16} className="text-[#FF6B1A]" /> New York, NY
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-2">
                        <div className="eyebrow text-[#FF6B1A] mb-4">Company</div>
                        <ul className="space-y-3 text-white/70">
                            <li><Link to="/about" className="hover:text-white">About</Link></li>
                            <li><Link to="/how-it-works" className="hover:text-white">How It Works</Link></li>
                            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="eyebrow text-[#FF6B1A] mb-4">Solutions</div>
                        <ul className="space-y-3 text-white/70">
                            <li><Link to="/funding" className="hover:text-white">Funding Solutions</Link></li>
                            <li><Link to="/iso-partners" className="hover:text-white">ISO Partners</Link></li>
                            <li><Link to="/funding#programs" className="hover:text-white">Active Programs</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="eyebrow text-[#FF6B1A] mb-4">Legal</div>
                        <ul className="space-y-3 text-white/70">
                            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link></li>
                            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Service</Link></li>
                        </ul>
                        <Link
                            to="/admin"
                            className="mt-6 inline-flex items-center gap-2 border-2 border-[#FF6B1A] text-[#FF6B1A] px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] hover:bg-[#FF6B1A] hover:text-white transition-colors"
                            data-testid="footer-admin-btn"
                        >
                            Admin
                        </Link>
                    </div>
                </div>

                <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between gap-4 text-sm text-white/55">
                    <div>© {new Date().getFullYear()} Lended. All rights reserved.</div>
                    <div className="font-mono text-xs">
                        Lended is not a bank. Funding products are merchant cash advances and revenue-based financing offered to qualifying businesses.
                    </div>
                </div>
            </div>
        </footer>
    );
}
